// Deaded Enemy Rewards — every upgrade in the game is now a temporary,
// in-run reward picked from the 3-card chooser. No permanent shop, no coin
// spending. Each pick stacks up to maxLevel for the current run only.
export const RUN_POWERS = {
  // ----- core beam / movement upgrades (formerly the coin shop)
  beamSize: {
    id: "beamSize",
    name: "Beam Size+",
    description: "Tractor beam is 25% wider per level.",
    icon: "Zap",
    maxLevel: 10,
  },
  beamPull: {
    id: "beamPull",
    name: "Beam Pull+",
    description: "Tractor beam pulls 30% faster per level.",
    icon: "Zap",
    maxLevel: 10,
  },
  beamHold: {
    id: "beamHold",
    name: "Beam Hold+",
    description: "Beam can be held +2 seconds longer per level.",
    icon: "Zap",
    maxLevel: 10,
  },
  ufoBoost: {
    id: "ufoBoost",
    name: "UFO Boost",
    description: "UFO moves 15% faster per level.",
    icon: "Rocket",
    maxLevel: 10,
  },
  freeze: {
    id: "freeze",
    name: "Zombie Freeze",
    description: "Beam briefly slows zombies. Stronger per level.",
    icon: "Sparkles",
    maxLevel: 10,
  },
  coinBoost: {
    id: "coinBoost",
    name: "Coin Boost",
    description: "+25% coins per zombie per level (this run).",
    icon: "Sparkles",
    maxLevel: 10,
  },
  // ----- auto-attack helpers
  laser: {
    id: "laser",
    name: "Auto Laser",
    description: "UFO auto-zaps the nearest zombie. Faster per level.",
    icon: "Zap",
    maxLevel: 10,
  },
  magnet: {
    id: "magnet",
    name: "Tractor Magnet",
    description: "Pulls nearby zombies toward the UFO. Stronger per level.",
    icon: "Sparkles",
    maxLevel: 10,
  },
  // ----- big-fun rewards
  lightning: {
    id: "lightning",
    name: "Sky Lightning",
    description: "Purple-white bolts strike zombies. Bigger and more often per level.",
    icon: "Cloud",
    maxLevel: 10,
  },
  companion: {
    id: "companion",
    name: "Companion Ships",
    description: "Wingman UFOs fire weaker green beams next to you.",
    icon: "Rocket",
    maxLevel: 10,
  },
  tripleBeam: {
    id: "tripleBeam",
    name: "Triple Beam",
    description: "Main beam +20% wider per level.",
    icon: "Zap",
    maxLevel: 5,
  },
  wheel: {
    id: "wheel",
    name: "Rolling Wheel",
    description: "A spinning wheel orbits and crushes zombies it touches.",
    icon: "Disc",
    maxLevel: 10,
  },
  ball: {
    id: "ball",
    name: "Bouncing Ball",
    description: "A neon ball bounces around zapping zombies on impact.",
    icon: "Sparkles",
    maxLevel: 10,
  },
  dog: {
    id: "dog",
    name: "Super Dog",
    description: "A loyal pup chases down the nearest zombie and tackles it.",
    icon: "Dog",
    maxLevel: 10,
  },
};

export const DEFAULT_RUN_POWERS = {
  beamSize: 0,
  beamPull: 0,
  beamHold: 0,
  ufoBoost: 0,
  freeze: 0,
  coinBoost: 0,
  laser: 0,
  magnet: 0,
  lightning: 0,
  companion: 0,
  tripleBeam: 0,
  wheel: 0,
  ball: 0,
  dog: 0,
};

// Legacy permanent-upgrades structure — kept as empty so any saved state
// from before this change doesn't break loadSave().
export const UPGRADES = {};
export const DEFAULT_UPGRADES = {};
export function getUpgradePrice() { return Infinity; }
export function getUpgradeValue() { return 0; }
